import { z } from 'zod/v4';

export const UserDTO = z.object({
  id: z.string(),
  discordId: z.string(),
  username: z.string(),
  avatar: z.string(),
  accessToken: z.string(),
  refreshToken: z.string(),
  isAdmin: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

const UserModel = z.object({
  id: z.string(),
  discordId: z.string(),
  username: z.string(),
  avatar: z.string(),
  accessToken: z.string(),
  refreshToken: z.string(),
  isAdmin: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type UserDTO = z.infer<typeof UserDTO>;
export type UserModel = z.infer<typeof UserModel>;

export class User implements UserModel {
  public id: string;
  public discordId: string;
  public username: string;
  public avatar: string;
  public accessToken: string;
  public refreshToken: string;
  public isAdmin: boolean;
  public createdAt: Date;
  public updatedAt: Date;

  constructor(user: UserDTO) {
    this.id = user.id;
    this.discordId = user.discordId;
    this.username = user.username;
    this.avatar = user.avatar;
    this.accessToken = user.accessToken;
    this.refreshToken = user.refreshToken;
    this.isAdmin = user.isAdmin;
    this.createdAt = new Date(user.createdAt);
    this.updatedAt = new Date(user.updatedAt);
  }

  static validate(userData: User) {
    const user = UserModel.safeParse(userData);
    if (!user.success) {
      throw new Error('Invalid user data');
    }
    return user.data;
  }
}
